





















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class CommonButton extends Vue {
  @Prop({default: ''})
  private label!: string;

  @Prop({default: false})
  private block?: boolean;

  @Prop({default: false})
  private disabled?: boolean;

  @Prop({default: false})
  private loading?: boolean;

  @Prop({default: false})
  private xSmall?: boolean;

  @Prop({default: false})
  private small?: boolean;

  @Prop({default: false})
  private large?: boolean;

  @Prop({default: true})
  private medium?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop({default: ''})
  private prefix?: string;

  @Prop()
  private color?: string;

  private handleClick(e:any) {
    this.$emit('click', e);
  }
}
